
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Grid, TextField } from "@mui/material"
import { BotonesAndCargando } from "../../components/botones";
import { useLotesStore } from "../../../stores";
import { useQueryClient } from "@tanstack/react-query";
import { DateFormScreen, NumberFormatCustom } from "../../components";
import { crearLoteStock } from "../../../services";

import Swal from "sweetalert2";




export const FormCrearUpdateLote = ({ handleCerrarModalInv }) => {


    const { id } = useParams();
    const queryClient = useQueryClient();
    const { activarLote } = useLotesStore();
    const millares = NumberFormatCustom;
    const [cargando, setCargando] = useState(false);
    

    useEffect(() => {
        if( activarLote ) {
            setFormInventario((items) => ({
                cantidadDisponible: activarLote.cantidadDisponible || "", 
                precioUnitario: activarLote.precioUnitario || "", 
                fechaIngreso: activarLote.fechaIngreso || ""
            }));
        }
    }, [activarLote])



    const [ formInventario, setFormInventario ] = useState({ cantidadDisponible:"", precioUnitario:"", fechaIngreso:"" });
    const { cantidadDisponible, precioUnitario, fechaIngreso } = formInventario;
    const handleInputChange = ({ target }) => {
        setFormInventario({
            ...formInventario,
            [target.name]: target.value
        });
    }



    const handleChangeStart = (newValue) => {
        setFormInventario( (resultado) => ({ ...resultado, fechaIngreso:newValue.toDate() }));
    };
    

    
    const handleCrearInventario = async(e) => {
        e.preventDefault();
        if( [cantidadDisponible, precioUnitario, fechaIngreso].includes('') ) {
            return Swal.fire('Error', 'Todos los campos son obligatorios', 'error');
        }
        setCargando(true);
        const resp = await crearLoteStock({ ...formInventario, stock:id, id:activarLote?._id });
        setCargando(false);

        if( resp ){
            queryClient.invalidateQueries({ queryKey: ['lotesXstock'] });
            handleCerrarModalInv();
        }
    }



    return (

        <form  onSubmit={ handleCrearInventario }>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        label="Cantidad"
                        type='number'
                        fullWidth
                        placeholder='Cantidad'
                        name="cantidadDisponible"
                        value={ cantidadDisponible }
                        onChange={ handleInputChange }
                        size="small"
                    >
                    </TextField>
                </Grid>


                <Grid item xs={12}>
                    <TextField 
                        variant="outlined"
                        label='Valor Unitario'
                        placeholder='Valor Unitario'
                        fullWidth
                        name="precioUnitario"
                        value={ precioUnitario }
                        onChange={ handleInputChange }
                        InputProps={{ inputComponent: millares }}
                        size="small"
                    />
                </Grid>

                <Grid item xs={12}>
                    <DateFormScreen
                        label="Fecha de Gasto"
                        value={fechaIngreso}
                        onChange={handleChangeStart}
                        permitirPasado={true}
                    />
                </Grid>
                
                
            </Grid>

            <Grid container sx={{mb:2, mt:3, display:'flex', justifyContent:'center' }}>
                <Grid item xs={12} sm={6} md={5}>
                    <BotonesAndCargando
                        cargando={cargando}
                        titulo={`${(activarLote) ? 'Editar' : 'Crear' } Lote`}
                        titulo2="Loading..."
                        icon1="save"
                        icon2="save"
                        esSubmit
                    />
                </Grid>
            </Grid>

        </form>
    )



}
